<script>
    import HtmlMap from "../_components/HtmlMap.svelte";
    import MapContainer from "../_components/MapContainer.svelte";

    /** @type { import("../scripts/charts.js").PageContext } */
    export let ctx;

    /** @type {string} */
    export let eastPng = "";
    /** @type {string} */
    export let westPng = "";
    /** @type {string} */
    export let swipeSvg = "";

    // For safety, assume small (mobile) window as initial value. This should be
    // immediately overwritten by binding when component is hydrated/mounted.
    let window_width = 375;

    $: switchToHtmlMap = window_width <= 700;
</script>

<svelte:window bind:innerWidth={window_width} />
<!-- Wrapper div ("county-map") needs to live in this component due to a
    devious bug with our hydrate script: can't have {#if} block at top level
    when `onMount` uses async code 😵‍💫 -->
<div id="county-map">
    {#if switchToHtmlMap && ctx["type"] == "homepage"}
        <HtmlMap {window_width} us_east={eastPng} us_west={westPng} />
    {:else}
        <MapContainer {switchToHtmlMap} {ctx} {swipeSvg} {window_width} />
    {/if}
</div>

<style lang="scss">
</style>
